'use client'

import type { ReactNode } from 'react'

import { hasDelmanDevice } from '@/shared/auth/delmanDeviceStorage'
import { hasDelmanSession } from '@/shared/auth/delmanSessionStorage'
import { ClientRedirect } from '@/shared/components/ClientRedirect'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function DelmanGuard({ children }: { children: ReactNode }) {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return <div className="min-h-screen bg-surface" aria-hidden />
  }

  if (!hasDelmanDevice()) {
    return <ClientRedirect href="/delman/activate" />
  }
  if (!hasDelmanSession()) {
    return <ClientRedirect href="/delman/login" />
  }
  return <>{children}</>
}
